export default __webpack_public_path__ + "static/media/chatting.dc2e63eb.svg";